import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import { Card, CardContent, Typography } from "@mui/material";
import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import { updatePasswordCandidate } from "../../../../graphql/mutations";
import { userDataSelector } from "../../../../shared/globalStates";
import { toastError, toastSuccess } from "../../../../shared/helpers";

export default function Password({ open, handleClose }) {
  const client = useApolloClient();
  const [errMsg, setErrMsg] = useState("");
  const userData = useRecoilValue(userDataSelector);
  const [values, setValues] = useState({
    email: userData.email,
    password: null,
    confirmPass: null,
  });

  const handleSubmit = async () => {
    if (!values.email || !values.password || !values.confirmPass) {
      setErrMsg("Password cannot be empty!");
    } else {
      if (values.password !== values.confirmPass) {
        setErrMsg("Password does not match! Please check your password again!");
      } else {
        const update = await updatePasswordCandidate(client, values);
        if (update.status !== "000") {
          toastError();
        } else {
          toastSuccess("Change password successfully");
          handleClose();
        }
      }
    }
  };

  return (
    <React.Fragment>
      <Card sx={{ width: "450px" }}>
        <CardContent>
          <Typography variant="h2" m="10px" my={1}>
            Change Password
          </Typography>
          <FormGroup
            showChildErrorSign
            errorMessage={errMsg}
            isError={errMsg}
            className="font-size-main"
            label="New Password"
            style={{ margin: "10px" }}>
            <Input
              id="new__password"
              type="password"
              placeholder="New Password"
              value={values.password}
              onChange={(e) =>
                setValues({
                  ...values,
                  password: e.target.value,
                })
              }
              required></Input>
          </FormGroup>
          <FormGroup
            showChildErrorSign
            errorMessage={errMsg}
            isError={errMsg}
            className="font-size-main"
            label="Confirm New Password"
            style={{ margin: "10px" }}>
            <Input
              id="confirm__password"
              type="password"
              placeholder="Confirm New Password"
              value={values.confirmPass}
              onChange={(e) =>
                setValues({
                  ...values,
                  confirmPass: e.target.value,
                })
              }
              required></Input>
          </FormGroup>
          <div className="button text-center my-2">
            <Button
              onClick={() => handleClose()}
              variant="outlined"
              color="danger"
              style={{ marginRight: "25px" }}>
              Cancel
            </Button>
            <Button onClick={handleSubmit} variant="contained">
              Change Password
            </Button>
          </div>
        </CardContent>
      </Card>
    </React.Fragment>
  );
}
